export const FormLabel = {
  baseStyle: {
    color: 'gray.800',
    marginEnd: '8px',
  },
};
